module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      George Alec Effinger\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("George A. Effinger was born in Cleveland, Ohio, in 1947. He attended Yale University, where an organic chemistry course disabused him of the notion of becoming a doctor. He had the opportunity to meet many of his science fiction idols thanks to his first wife, who was Damon Knight and Kate Wilhelm’s babysitter. With their encouragement, he began writing science fiction in 1970. He published at least twenty novels and six collections of short fiction, including "), _c('I', [_vm._v("When Gravity Fails")]), _vm._v(" and "), _c('I', [_vm._v("The Exile Kiss")]), _vm._v(". He also wrote and published two crime novels, "), _c('I', [_vm._v("Felicia")]), _vm._v(" and "), _c('I', [_vm._v("Shadow Money")]), _vm._v(". With his Budayeen novels, Effinger helped to found the cyberpunk genre. He was a Hugo and Nebula Award winner and is a favorite among fellow science fiction writers.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/aYqLUh/tc-custom/9781497605435.jpg?1701348805381",
      "alt": "This image is the cover for the book What Entropy Means to Me"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("What Entropy Means to Me\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Nebula Award Finalist")]), _c('br'), _c('br'), _vm._v(" Doctor, watch out! As Dore stood by, he saw the Doctor backing slowly into the corner where he would meet his fate. Initially defending himself with a torch, the Doctor searched frantically for a new method of defense. The crimson mass is lunging forward using long, tentacle-like attachments: what is that thing? Slowly the subhuman blob comes in to focus, and Dore realizes...it's a colossal radish! This is a monster never before wrestled with; what are they going to do? After reading this vegetative tale, you won't look at your garden the same way again. \n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0